module.exports = __webpack_public_path__ + "img/BlinkArt_Sword4_Yellow.87ab11b8.png";